<template>
  <div class="link-wrap">
    <!--lastExamResult 上次考试结果，0-未考过、1-及格、2-不及格 -->
    <template v-if="item.times === 1">
      <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">开始答题</a>
      <a :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1 || deadlineTimeout(item.deadline))">答题解析</a>
    </template>
    <template v-else-if="item.times === 999">
      <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">开始答题</a>
      <a :href="item.examUrl" class="button" target="_blank" title="再考一次" v-if="!deadlineTimeout(item.deadline) && item.examUrl && (item.lastExamResult === 1 || item.lastExamResult === 2)">再考一次</a>
      <a :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 1 || item.lastExamResult === 2 || deadlineTimeout(item.deadline))">答题解析</a>
    </template>
    <template v-else>
      <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">开始答题</a>
      <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 2 && item.makeupCount > 0">{{`不及格，还能补考${item.makeupCount}次`}}</a>
      <a :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1 || deadlineTimeout(item.deadline))">答题解析</a>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    deadlineTimeout (item) {
      if (item && Date.now() > item && item > new Date('2000/01/01 00:00:00').getTime()) {
        return true
      }
      return false
    }
  }
}
</script>


<style lang="scss" scoped>
.link-wrap{
  .button {
    display: inline-block;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    background-color:#FD3374;
    color: #fff;
    width: 104px;
    height: 34px;
    line-height: 34px;
    border-radius: 20px;
    margin-top: 35px;
    padding: 0 10px;
    margin-left: 10px;
    &.info {
      border: 1px solid #D3D6DA;
      background: #fff;
      color:#666;
    }
  }
}
</style>